import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { FileArchiveDto, PdfResponse } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/file-archive`;

export const findFileArchiveEntries = (
    searchTerm: string,
    source: CancelTokenSource): Promise<FileArchiveDto[]> => {

  return axios
      .post(`${apiUri}/search`, null, {params: {searchTerm: searchTerm}, cancelToken: source.token})
      .then((response) => response.data);
};

export const getFileDownloadKey = (
    fileArchiveId: string,
    source: CancelTokenSource): Promise<PdfResponse> => {

  return axios.get(`${apiUri}/${fileArchiveId}/download-key`, {cancelToken: source.token})
      .then(response => response.data);
};

export const getFileUrl = (downloadKey: string, fileName: string) => {
  return `${baseUrl}/cqv3tsaetqzjlh8esqylge0ei097p8o4/${downloadKey}/${fileName}`;
};

export const removeFileArchiveDuplicates = (
    source: CancelTokenSource)
    : Promise<void> => {

  return axios
      .post(`${apiUri}/remove-file-archive-duplicates`, null, {cancelToken: source.token})
      .then(response => response.data);
}
